import React from "react";
import styled from "styled-components";

const CustomFooter = styled.footer`
  background: linear-gradient(90deg, #C62828, #FF5252);
  color: #ffffff;
  padding: 50px 20px 30px;
  box-sizing: border-box;
  border-top: 2px solid rgba(0, 0, 0, 0.7);
`;

const CustomFooterContent = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 30px;
`;

const CustomSection = styled.div`
  flex: 1;
  min-width: 200px;
`;

const CustomSectionTitle = styled.h3`
  font-size: 22px;
  margin-bottom: 12px;
  font-weight: 500;
  color: #FFEB3B;
`;

const CustomText = styled.p`
  font-size: 14px;
  margin-bottom: 6px;
  line-height: 1.4;
`;

const CustomFooterLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  display: block;
  margin-bottom: 6px;
  transition: color 0.3s;

  &:hover {
    color: #FFEB3B;
  }
`;

const CustomFooterBottom = styled.div`
  text-align: center;
  border-top: 1px solid rgba(0, 0, 0, 0.6);
  padding-top: 15px;
  font-size: 12px;
  margin-top: 20px;
`;

const Footer = () => {
  return (
      <CustomFooter>
        <CustomFooterContent>
          <CustomSection>
            <CustomSectionTitle>Troniq.news</CustomSectionTitle>
            <CustomText>Adresse: 15 Straße des Fortschritts, 10115 Berlin, Deutschland</CustomText>
            <CustomText>Telefon: +49 30 12345678</CustomText>
            <CustomText>Email: kontakt@troniq.news</CustomText>
          </CustomSection>
          <CustomSection>
            <CustomSectionTitle>Links</CustomSectionTitle>
            <CustomFooterLink href="/" target="_blank" rel="noopener noreferrer">
              Startseite
            </CustomFooterLink>
            <CustomFooterLink href="/about" target="_blank" rel="noopener noreferrer">
              Über uns
            </CustomFooterLink>
            <CustomFooterLink href="/contact" target="_blank" rel="noopener noreferrer">
              Kontakt
            </CustomFooterLink>
            <CustomFooterLink href="/policy" target="_blank" rel="noopener noreferrer">
              Datenschutzrichtlinie
            </CustomFooterLink>
          </CustomSection>
          <CustomSection>
            <CustomSectionTitle>Folgen Sie uns</CustomSectionTitle>
            <CustomFooterLink
                href="https://www.facebook.com/Troniq.news"
                target="_blank"
                rel="noopener noreferrer"
            >
              Facebook
            </CustomFooterLink>
            <CustomFooterLink
                href="https://twitter.com/Troniq_news"
                target="_blank"
                rel="noopener noreferrer"
            >
              Twitter
            </CustomFooterLink>
            <CustomFooterLink
                href="https://www.linkedin.com/company/troniq-news"
                target="_blank"
                rel="noopener noreferrer"
            >
              LinkedIn
            </CustomFooterLink>
            <CustomFooterLink
                href="https://www.instagram.com/troniq.news"
                target="_blank"
                rel="noopener noreferrer"
            >
              Instagram
            </CustomFooterLink>
          </CustomSection>
        </CustomFooterContent>
        <CustomFooterBottom>
          &copy; {new Date().getFullYear()} Troniq.news. Alle Rechte vorbehalten.
        </CustomFooterBottom>
      </CustomFooter>
  );
};

export default Footer;